import { createApiInstance } from './handler';
import { DateTime } from 'luxon';
import { buildMetadataQuery, findMetadataAttributeNameById, getTargetFilters } from './metadata';
import { getGlobalValue, setGlobalValue } from '../utils/global-storage';

const STORED_PARTICIPATION_STATUSES = 'hutrics.participation.statuses';

const getStoredParticipationStatuses = () => {
  return getGlobalValue(STORED_PARTICIPATION_STATUSES);
};
const storeParticipationStatuses = (participationStatuses) => {
  setGlobalValue(STORED_PARTICIPATION_STATUSES, participationStatuses);
};

export const buildParticipantSummaries = (participants) => {
  const userSummary = [
    {
      status: 'In Progress',
      count: 0,
    },
    {
      status: 'Not Started',
      count: 0,
    },
    {
      status: 'Completed',
      count: 0,
    },
  ];
  const ratersSummary = [
    {
      status: 'In Progress',
      count: 0,
    },
    {
      status: 'Not Started',
      count: 0,
    },
    {
      status: 'Completed',
      count: 0,
    },
  ];

  participants.forEach((participantStatus) => {
    if (participantStatus.ratersAssigned > 0) {
      ratersSummary[2].count += participantStatus.ratersSubmitted;
      ratersSummary[0].count += participantStatus.ratersStarted - participantStatus.ratersSubmitted;
      ratersSummary[1].count += participantStatus.ratersAssigned - participantStatus.ratersStarted;
    }

    if (participantStatus.assessmentsSubmitted) {
      userSummary[2].count += 1;
    } else if (participantStatus.assessmentsStarted) {
      userSummary[0].count += 1;
    } else {
      userSummary[1].count += 1;
    }
  });
  return {
    userSummary: userSummary,
    ratersSummary: ratersSummary,
  };
};

export const getUserParticipationStatuses = async (auth, develop = true) => {
  const storedParticipationStatuses = getStoredParticipationStatuses();
  if (storedParticipationStatuses) {
    return storedParticipationStatuses;
  }

  const userParticipationStatuses = [];

  try {
    const targetFilters = await getTargetFilters(auth);

    const response = await createApiInstance(auth, 'client').get(
      `/aggregation/participation?employees=${develop ? '1' : '0'}&limit=1000${buildMetadataQuery(targetFilters)}`
    );
    if (response.data?.length) {
      for (const status of response.data) {
        const participationStatus = {
          userId: status.target_user_id,
          userName: status.target_user_name,
          dateAssigned: DateTime.fromISO(status.date_assigned).toLocal(),
          assessmentsAssigned: status.assessments_assigned,
          assessmentsStarted: status.assessments_started,
          assessmentsSubmitted: status.assessments_submitted,
        };

        if (status.date_expires) {
          participationStatus.dateExpires = DateTime.fromISO(status.date_expires).toLocal();
        }

        if (develop) {
          participationStatus.ratersAssigned = status.raters_assigned;
          participationStatus.ratersStarted = status.raters_assigned_started;
          participationStatus.ratersSubmitted = status.raters_assigned_submitted;
        }

        if (status.metadata_attributes?.length) {
          participationStatus.metadata = {};
          const attributeIds = status.metadata_attributes;
          const attributeValues = status.metadata;
          for (let a = 0; a < attributeIds.length; a++) {
            const id = attributeIds[a];
            const attributeName = await findMetadataAttributeNameById(auth, id);
            participationStatus.metadata[attributeName] = attributeValues[a];
          }
        }

        if (status.position_manager_name?.length) {
          participationStatus.position = {};
          participationStatus.position.hiringManager = status.position_manager_name;
          participationStatus.position.title = status.position_title;
          participationStatus.position.reference = status.position_reference;
        }

        userParticipationStatuses.push(participationStatus);
      }
    }
  } catch (error) {
    console.error(error);
  }

  storeParticipationStatuses(userParticipationStatuses);

  return userParticipationStatuses;
};
